import { StaticImage } from "gatsby-plugin-image";
import React, { useState, useRef } from "react";
import SectionTitle from "./SectionTitle";
import emailjs from "emailjs-com";

const Contact = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const form = useRef();

  function handleShowAlert() {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  }
  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .send(
        "my_portfolio",
        "template_3zmtufg",
        {
          name: name,
          subject: subject,
          email: email,
          message: message,
          reply_to: email,
        },
        "user_Nyxj6sTmbdOQ7C8YLVuS2"
      )
      .then(
        (result) => {
          setLoading(false);
          handleShowAlert();
          setName("");
          setEmail("");
          setSubject("");
          setMessage("");
        },
        (error) => {
          setLoading(false);
          console.log(error.text);
        }
      );
  };
  return (
    <div
      id="contact"
      className="w-full md:min-h-screen flex flex-col items-center md:items-start justify-center px-4 md:px-20 py-20"
    >
      <SectionTitle highlight="Say hello" section="Lets Connect" />
      <div className="w-full flex flex-col items-center 2xl:px-10 md:py-10">
        <div className="w-full xl:w-4/5 flex flex-col lg:flex-row items-center justify-evenly lg:border lg:border-gray-200 lg:rounded-lg py-20">
          <div className="w-full xl:w-1/2 my-5 lg:my-0 flex flex-col items-start justify-evenly sm:px-10 lg:border-r-2 lg:border-gray-300">
            <h2 className="text-2xl font-custom font-medium">Get in Touch</h2>
            <ul className="mt-10">
              <li className="my-4 flex items-start">
                <StaticImage
                  src="../images/contact/address.png"
                  alt="Address"
                  placeholder="dominantColor"
                  layout="constrained"
                  className="w-8 h-8 object-cover mr-3"
                />
                <span className="text-base sm:text-lg font-normal text-gray-800 font-custom">
                  Street 14, Rahim yar khan, Pakistan
                </span>
              </li>
              <li className="my-4 flex items-start">
                <StaticImage
                  src="../images/contact/phone.png"
                  alt="Phone"
                  placeholder="dominantColor"
                  layout="constrained"
                  className="w-8 h-8 object-cover mr-3"
                />
                <span className="text-base sm:text-lg font-normal text-gray-800 font-custom">
                  +92 (303) 8330573
                </span>
              </li>
              <li className="my-4 flex items-start">
                <StaticImage
                  src="../images/contact/mail.png"
                  alt="Mail"
                  placeholder="dominantColor"
                  layout="constrained"
                  className="w-8 h-8 object-cover mr-3"
                />
                <span className="text-base sm:text-lg font-normal text-gray-800 font-custom">
                  usamatahir8330@gmail.com
                </span>
              </li>
            </ul>
          </div>
          <form
            className="w-full xl:w-1/2 my-5 lg:my-0 flex flex-col items-start justify-evenly sm:px-10"
            ref={form}
            onSubmit={sendEmail}
          >
            <h2 className="text-2xl font-custom font-medium my-5">
              Contact Form
            </h2>
            <input
              type="text"
              value={name}
              name="name"
              onChange={(e) => setName(e.target.value)}
              placeholder="Your Name"
              className="border-2 border-gray-400 rounded-md px-2 py-1 my-3 font-custom text-sm h-10 w-full xl:w-2/3"
              required
            />
            <input
              type="email"
              value={email}
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your Email"
              className="border-2 border-gray-400 rounded-md px-2 py-1 my-3 font-custom text-sm h-10 w-full xl:w-2/3"
              required
            />
            <input
              type="text"
              value={subject}
              name="subject"
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Your Subject"
              className="border-2 border-gray-400 rounded-md px-2 py-1 my-3 font-custom text-sm h-10 w-full xl:w-2/3"
              required
            />
            <textarea
              value={message}
              name="message"
              onChange={(e) => setMessage(e.target.value)}
              rows={3}
              placeholder="Your Message"
              className="border-2 border-gray-400 rounded-md px-2 py-1 my-3 font-custom text-sm w-full xl:w-2/3"
              required
            />

            <button
              type="submit"
              disabled={loading}
              className="font-custom text-lg font-medium my-5 text-white bg-primary w-32 h-10 rounded-lg "
            >
              Send
            </button>
          </form>
        </div>
      </div>

      {showAlert && (
        <div className="w-full md:w-1/5 mx-auto fixed top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-between shadow bg-white border-2 border-green-500 rounded-lg">
          <div className="flex p-5 ">
            <div>
              <svg
                className="w-6 h-6 fill-primary text-green-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z" />
              </svg>
            </div>
            <div className="ml-3">
              <h2 className="font-semibold text-green-600">
                Message sent successfully
              </h2>
            </div>
          </div>
          <span
            className="flex items-center mr-4"
            onClick={() => setShowAlert(false)}
          >
            <svg
              className="w-6 h-6 fill-primary"
              role="button"
              viewBox="0 0 20 20"
            >
              <path
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
                fillRule="evenodd"
              ></path>
            </svg>
          </span>
        </div>
      )}
    </div>
  );
};

export default Contact;
